import React from 'react';
import axios from 'axios';
import {
  CSRF_TOKEN,
  addNotification,
} from '../../lib/helpers';
import Notification from '../Notification'

const KillPalButton = ({
  tokenId
}) => {
  const killPal = (palTokenId) => {
    if (confirm('Are you sure to KILL this Pal?')) {
      axios.post(`/${gon.currentProvider}/api/pals/${palTokenId}/kill`, { authenticity_token: CSRF_TOKEN,})
        .then((res) => {
          if (res.status === 200) {
            addNotification({
              message: `Pal ${palTokenId} killed successfully`,
              type: Notification.NOTIFICATION_TYPES.success,
            })
          }
        })
        .catch((error) => {
          addNotification({
            message: 'Something went wrong',
            type: Notification.NOTIFICATION_TYPES.error,
          })
        })
        .then(() => {
          window.location.reload()
        })
    }
  }

  return (
    <a
      className='Button'
      onClick={
        () => { killPal(tokenId) }
      }
    >
      Kill
    </a>
  );
}

export default KillPalButton;
